import React, { useState, useEffect } from 'react';
import { getRol } from '../../../_utils/storage_handler';
import { ROLES } from '../../../_config/roles';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { Checkbox } from 'antd';
import { 
  findOrdersEvent
} from '../../../_events/orders/find_order.event';
import { aproverOrdersEvent, deleteOrdersEvent, displayPDFOrderEvent } from '../../../_events/orders/order_box.event';
import { message } from 'antd';
import PrimaryProgress from '../../../containers/progress/primary_progress';
import Dry_cleanerBoxList from './dry_cleaner_list';
import Chip from '@mui/material/Chip';
import BasicPopconfirm from '../../../containers/popconfirms/basic_popconfirm';
import { 
  buildOrderBoxBody, 
  validateOrderBoxBody
} from '../../../_events/orders/order_box.input';
import { isNotViewer } from '../../../_utils/render_actions';
import { downloadExcelFile } from '../../../_utils/download_file.util';
import ModalBarcode from './modal_barcode';

const Dry_cleanerBox = () => {

  const in_process='TINT';
  const [allChecked, setAllChecked] = useState(false);
  const [order, setOrder] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [openPDF, setOpenPDF] = React.useState(false);
  const [pdf, setPDF] = React.useState(null);
  const [process_state, setProcess_state] = useState([]);
  const [product_weight, setProduct_weight] = useState([]);
  const [customer_formulas, setCustomer_formulas] = useState([]);
  
  const handleOpen = () => {         
      setOpen(true);                 
  };

  const handleClose = () => {
      setOpen(false);
  };

  const handleClosePDF = () => {
    setOpenPDF(false);
  };

  const loadOrders = () => {
    setAllChecked(false);
    setLoading(false);
    findOrdersEvent('TINT')
    .then(data => {
      let orders_list = [];
      let process_list = [];
      let customer_formulas=[];
      let product_weight=[];
      data.list.forEach(obj => {  
        if (obj.uuid != null && obj.id) {  
          orders_list.push(obj);
        } else if(obj.name!=null && obj.cod!=null && obj.cod!='TINT' && obj.cod!='ALIS' ) {
          process_list.push(obj);
        }else if(obj.id!=null && obj.machine!=null) {
          customer_formulas.push(obj);
        }else if(obj.uuid!=null && obj.kilo!=null) {
          product_weight.push(obj);
        } 
      });
      setOrders(orders_list);
      process_list.sort((a, b) => (a.cod === 'DEFE') ? -1 : ((b.cod === 'DEFE') ? 1 : 0));
      setProcess_state(process_list);
      setCustomer_formulas(customer_formulas);
      setProduct_weight(product_weight);
      setLoading(false);
    })
    .catch(err => {
      message.error(err.message);
      setLoading(false);
    });
  }

  const setEditOrder = (o, p) => {
    setOrder({uuid: p.uuid, order: o});
    handleOpen();
  }

  const aprove = () => {
    let selectedOptions = []; 
    orders.forEach((order) => {
      let count = 0;
      order.ordersDetail.forEach((orderDetail) => {        
        const selectElement = document.querySelector(`select[data-uuid="${orderDetail.uuid}"]`); 
        if (selectElement){
          selectedOptions.push(selectElement.value);
        }else{
          count=1;
        }
      });
      if(count>0){
        selectedOptions.push(`all-defect-i//${order.uuid}`);
        count=0;
      }
    });
    aproverOrdersEvent(orders,selectedOptions,in_process)
    .then(data => {
      //downloadExcelFile(data.data.toAproveJSON,"ordenes");
      message.success('Productos enviados.');
      loadOrders();
    })
    .catch(err => {
      message.error(err.message);
    });
  };
  

  const deleteOrder = (order) => {
    deleteOrdersEvent(order.uuid)
    .then(data => {
      message.success('Orden eliminada');
      loadOrders();
    })
    .catch(err => {
      message.error(err.message);
    });
  }

  const checkAll = () => {
    let check = allChecked;
    let ordersNew = [...orders];
    ordersNew.forEach(element => {
      element.checked = check ? 0 : 1;
    });
    setAllChecked(!check);
    setOrders(ordersNew);
  }

  const displayPDF = (order) => {
    if(! order) message.error('No hay orden');
    else {
      let o = Object.assign({}, order);
      displayPDFOrderEvent(o)
      .then(data => {
        setPDF(data.data.toAproveJSON);
        setOpenPDF(true);     
      })
      .catch(err => {
        message.error(err.message);
      });
    }    
  }

  useEffect(() => {
    loadOrders();
  }, []);

  let rol = getRol();

  return (
    <Grid container spacing={1} >
        <Grid item xs={12} md={12}>
            <Typography variant="h6" component="h6">
                Bandeja de Tintoreria 
            </Typography>
            <hr />
            {
              loading ? (
                <PrimaryProgress />
              ) : (
                <Grid container spacing={1}>
                  <Grid item xs={6} md={6}>
                    <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                      <Chip label={`Total: ${orders.length}`} color="primary" variant="outlined" />
                      <Chip label={`Entregas INMEDIATAS: ${orders.filter(o => o.date_delivery === null).length}`} color="error" variant="outlined" />
                      <Chip label={`Seleccionadas: ${orders.filter(o => o.checked === 1).length}`} color="success" variant="outlined" />
                    </div>
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <div style={{display: 'flex', flexDirection: 'row-reverse', width: '100%'}}>
                      <BasicPopconfirm
                        label='Aprobar órdenes'
                        title='¿Seguro/a que deseas aprobar todas las órdenes seleccionadas?'
                        onConfirm={ () => { isNotViewer(rol) ? aprove() : alert('Usuario informativo')}}
                      />
                      <ModalBarcode loadOrders={loadOrders}/>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <div style={{width: '100%', display: 'flex', flexDirection: 'row-reverse'}}>
                      <Checkbox
                        style={{marginRight:'55px'}} 
                        checked={allChecked}
                        onClick={event => {
                                event.stopPropagation();
                        }}
                        onChange={() => {
                            checkAll();
                        }}>
                      </Checkbox>
                    </div>                 
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Dry_cleanerBoxList
                      
                      data={orders}
                      process={process_state}
                      setEditOrder={(o, p) => setEditOrder(o, p)}
                      updateDataOrdersChecked={(d) => {
                        let index = orders.findIndex(o => o.uuid === d.uuid);
                        if(index === -1){
                          message.error('No se logró seleccionar');
                        } else {
                          let orders_updated = [...orders];
                          orders_updated[index].checked = orders_updated[index].checked === 0 ? 1 : 0;
                          setOrders(orders_updated);
                        }
                      }}
                      deleteOrder = {(o) => {isNotViewer(rol) ? deleteOrder(o) : alert('Usuario informativo')}}
                      displayPDF = {(o) => displayPDF(o)}
                    />
                  </Grid>
                </Grid>
              )
            }
        </Grid>
       
    </Grid>
  );
}

export default Dry_cleanerBox;
